import { callZigzagFunction } from '../callZigzagFunction';

// 외부 브라우저 호출
export const openExternalBrowser = (url: string) => {
  callZigzagFunction('openExternalBrowser')({ url });
};
